import { Controller } from "@hotwired/stimulus"

// Couples can_create / can_send checkboxes per row.
//
// Rules:
//   - Checking "Envoyer" auto-checks "Créer"
//   - Unchecking "Créer" auto-unchecks "Envoyer"
//   - Unchecking "Envoyer" does NOT uncheck "Créer"
export default class extends Controller {
  static targets = ["row"]

  createChanged(event) {
    const row = event.target.closest("[data-comm-permission-target='row']")
    if (!row) return

    const sendBox = row.querySelector("[data-role='send']")
    if (!sendBox) return

    // Unchecking create → uncheck send
    if (!event.target.checked) {
      sendBox.checked = false
    }
  }

  sendChanged(event) {
    const row = event.target.closest("[data-comm-permission-target='row']")
    if (!row) return

    const createBox = row.querySelector("[data-role='create']")
    if (!createBox) return

    // Checking send → auto-check create
    if (event.target.checked) {
      createBox.checked = true
    }
  }
}
